import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Z",
  "use": "icon-Z-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Z\">\n<path d=\"M47.7131 14.392C45.1691 11.848 41.8091 10.456 38.2571 10.456C35.2331 10.456 32.3531 11.464 30.0011 13.288C24.7211 9.208 17.0891 9.544 12.2891 14.392C9.74513 16.936 8.35313 20.296 8.35313 23.848C8.35313 27.448 9.74513 30.808 12.2891 33.352L28.7531 49.864C29.0891 50.2 29.5691 50.392 30.0011 50.392C30.4331 50.392 30.9131 50.2 31.2491 49.864L47.7131 33.352C52.9451 28.12 52.9451 19.624 47.7131 14.392Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol